/**
 * Created by staffanrantzow on 28/10/16.
 */

import React, { PropTypes } from 'react';
import SupplierLedgerRow from './supplier-ledger-row';
import Translate from 'react-translate-component';

class SupplierLedgersTable extends React.Component {

  static propTypes = {
    supplierLedgers: PropTypes.array.isRequired,
    hideOrderNumber: PropTypes.bool,
    showDetailColumns: PropTypes.bool
  };

  renderRow (s, i) {
    return (<SupplierLedgerRow
      supplierLedger={s}
      hideOrderNumber={this.props.hideOrderNumber}
      showDetailColumns={this.props.showDetailColumns}
      key={i} />
    );
  }

  renderOrderNumberTh () {
    if (!this.props.hideOrderNumber) {
      return (<th className='col-ordernr'><Translate content='ORDER_NR'/></th>);
    }
  }

  renderDetailsArrived () {
    if (this.props.showDetailColumns) {
      return (<th className='col-arrived'><Translate content='ARRIVED'/></th>);
    }
  }

  renderDetailsStatus () {
    if (this.props.showDetailColumns) {
      return (<th className='col-status'><Translate content='STATUS'/></th>);
    }
  }

  renderDetailsPaid () {
    if (this.props.showDetailColumns) {
      return (<th className='col-paid'><Translate content='PAID_DATE'/></th>);
    }
  }

  render () {
    return (
      <div className='table-wrapper preview-section'>
        <table className='standard-table slim'>
          <thead>
            <tr>
              <th className='col-levid'><Translate content='LEV_ID'/></th>
              <th className='col-supplier'><Translate content='SUPPLIER'/></th>
              {this.renderOrderNumberTh()}
              {this.renderDetailsArrived()}
              {this.renderDetailsStatus()}
              {this.renderDetailsPaid()}
              <th className='col-sum'><Translate content='SUM'/></th>
            </tr>
          </thead>
          <tbody>
            {this.props.supplierLedgers.map(this.renderRow.bind(this))}
          </tbody>
        </table>
      </div>
    );
  }

}

export default SupplierLedgersTable;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/supplier-ledgers/supplier-ledgers-table.js
 **/